module.exports = __webpack_public_path__ + "static/img/share.f740077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share.png
// module id = yMUZ
// module chunks = 0